window.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("#hide-facets-btn");

  btn?.addEventListener("click", () => {
    const facetsFormVertical = document.querySelector(".facets__form-vertical");
    const facetsWrapperDesktop = document.querySelector("#FacetsWrapperDesktop");
    const verticalFacetsWithHide = document.querySelector(".vertical--facets-w-hide");
    const currentState = facetsWrapperDesktop.getAttribute("hide-facets");

    if (currentState === "true") {
      facetsWrapperDesktop.setAttribute("hide-facets", "false");
      facetsFormVertical.setAttribute("vertical-hide-facets", "false");
      verticalFacetsWithHide.setAttribute("form-hide-facets", "false");
    } else {
      facetsWrapperDesktop.setAttribute("hide-facets", "true");
      facetsFormVertical.setAttribute("vertical-hide-facets", "true");
      verticalFacetsWithHide.setAttribute("form-hide-facets", "true");
    }
  });
});
